import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

// Import sections
import Hero from "./Sections/Hero";
import Stats from "./Sections/Stats";
import SpeciesCount from "./Sections/SpeciesCount";
import SpeciesInfo from "./Sections/SpeciesInfo";
import Features from "./Sections/Features";
import Quick from "./Sections/Quick";
import Footer from "./Sections/Footer";
import Hardware from "./Sections/Hardware";
import Teams from "./Sections/Teams";

export default function Home() {
  const [stats, setStats] = useState({
    cameras: 0,
    events: 0,
    species: 0,
    users: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setStats({
          cameras: 24,
          events: 1247,
          species: 12,
          users: 156,
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* Introduction Section with Slideshow */}
      <Hero />

      {/* System Overview Section */}
      <Stats stats={stats} loading={loading} />

      {/* Species Detection Section */}
      <SpeciesCount />

      {/* Hardware Section */}
      <Hardware />

      {/* Species Information Section */}
      <SpeciesInfo />

      {/* Teams & Collaborators Section */}
      <Teams />

      {/* Platform Features Section */}
      <Features />

      {/* Quick Actions Section */}
      <Quick />

      {/* Footer */}
      <Footer />
    </Box>
  );
}
